import React, { useState, useRef, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { ButtonBase } from "@material-ui/core";
import {
  Inputs,
  SelectComponet,
  AutocompleteComponent,
} from "../../../../../../../../Components";
import { GetParams } from "../../../../../../.././../Helper";
import { GetLookupItemsByLookupTypeName } from "../../../../../../../../Services";
import { AMLTransactionStatusEnum } from "../../../../../../../../Enums/AMLTransactionStatus.Enum";
import { DateRangePickerComponent } from "../../../../../../../../Components/Controls/DateRangePickerComponent/DateRangePickerComponent";

export const CommissionsFilterComponent = ({
  contactId,
  parentTranslationPath,
  translationPath,
  filter,
  setFilter,
  filterValues,
  setFilterValues,
  setIsClearFiltersClicked,
  setDateFilter,
  dateRangeDefault,
  dateFilter,
  isDatePickerChanged,
  setIsDatePickerChanged,
  isClearFiltersClicked,
  reloadData,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const searchTimer = useRef(null);
  const [isLoading, setIsLoading] = useState({
    transactionStatus: false,
    commissionStatus: false,
  });
  const [data, setData] = useState({
    transactionStatus: [],
    commissionStatus: [],
  });

  const GetLookupItemsByLookupTypeNameAPI = useCallback(
    async (lookupName, key) => {
      setIsLoading(true);
      const res = await GetLookupItemsByLookupTypeName({
        lookUpName: lookupName,
        pageIndex: 1,
        pageSize: 150,
      });
      if (!((res && res.data && res.data.ErrorId) || !res)) {
        setData((data) => ({ ...data, [key]: res?.result }));
      } else setData([]);
      setIsLoading(false);
    }
  );

  return (
    <div>
      <div className="d-flex-column mt-3  mb-2">
        <div className="header-section mb-2 mt-2">
          <div className="filter-section">
            <div className="section"></div>
            <div className="section autocomplete-section">
              <div className="d-flex-column px-2 w-100 p-relative">
                <div className="w-100 d-flex d-flex-inline d-flex-h-center-h-start">
                  <div className="w-50 p-relative px-2">
                    <Inputs
                      idRef="leadIdRef"
                      type="number"
                      min={0}
                      value={filterValues.leadId || ""}
                      inputPlaceholder={t(`${translationPath}enter-lead-id`)}
                      onInputChanged={(event) => {
                        let newValue =
                          (event.target.value &&
                            event.target.value !== "" &&
                            +event.target.value) ||
                          null;
                        setFilterValues({
                          ...filterValues,
                          leadId: newValue,
                        });
                      }}
                      onKeyUp={(e) => {
                        if (searchTimer.current)
                          clearTimeout(searchTimer.current);
                        const newValue = e?.target?.value;
                        searchTimer.current = setTimeout(() => {
                          setFilter((item) => ({ ...item, leadId: newValue }));
                        }, 700);
                      }}
                      parentTranslationPath={parentTranslationPath}
                      translationPath={translationPath}
                    />
                  </div>
                  <div className="w-50 p-relative px-2">
                    <Inputs
                      idRef="leadNameRef"
                      value={filterValues?.leadName || ""}
                      inputPlaceholder={t(`${translationPath}enter-lead-name`)}
                      onInputChanged={(event) => {
                        let newValue =
                          (event.target.value &&
                            event.target.value !== "" &&
                            event.target.value) ||
                          null;

                        setFilterValues({
                          ...filterValues,
                          leadName: newValue,
                        });
                      }}
                      onKeyUp={(e) => {
                        if (searchTimer.current)
                          clearTimeout(searchTimer.current);
                        const newValue = e?.target?.value;
                        searchTimer.current = setTimeout(() => {
                          setFilter((item) => ({
                            ...item,
                            leadName: newValue,
                          }));
                        }, 700);
                      }}
                      parentTranslationPath={parentTranslationPath}
                      translationPath={translationPath}
                    />
                  </div>
                </div>
                <div className="w-100 d-flex d-flex-inline d-flex-h-center-h-start">
                  <div className="w-50 p-relative px-2">
                    <AutocompleteComponent
                      selectedValues={filterValues?.commissionStatus || null}
                      multiple={false}
                      inputPlaceholder={t(
                        `${translationPath}commission-status`
                      )}
                      data={data.commissionStatus || []}
                      displayLabel={(option) =>
                        t(`${option?.lookupItemName || ""}`)
                      }
                      getOptionSelected={(option) =>
                        option?.lookupsId ===
                        filterValues?.commissionStatus?.lookupsId
                      }
                      isLoading={isLoading?.commissionStatus}
                      parentTranslationPath={parentTranslationPath}
                      onOpen={() => {
                        if (data?.commissionStatus.length === 0)
                          GetLookupItemsByLookupTypeNameAPI(
                            "PSICommissionStatus",
                            "commissionStatus"
                          );
                      }}
                      withoutSearchButton
                      translationPath={translationPath}
                      onChange={(event, newValue) => {
                        setFilter((item) => ({
                          ...item,
                          commissionStatus:
                            (newValue?.lookupItemName &&
                              newValue.lookupItemName.toLowerCase()) ||
                            null,
                        }));
                        setFilterValues((item) => ({
                          ...item,
                          commissionStatus: newValue || null,
                        }));
                      }}
                    />
                  </div>
                  <div className="w-50 p-relative px-2">
                    <AutocompleteComponent
                      idRef="TransactionStatusIdRef"
                      selectedValues={filterValues?.transactionStatus}
                      inputPlaceholder={t(
                        `${translationPath}transaction-status`
                      )}
                      multiple={false}
                      data={[...Object.values(AMLTransactionStatusEnum)]}
                      displayLabel={(option) => t(`${option.title || ""}`)}
                      getOptionSelected={(option) =>
                        option.key === filterValues?.transactionStatus?.key
                      }
                      isLoading={isLoading?.commissionStatus}
                      parentTranslationPath={parentTranslationPath}
                      translationPath={translationPath}
                      onChange={(event, newValue) => {
                        setFilter((item) => ({
                          ...item,
                          transactionStatusId: newValue?.key || null,
                        }));
                        setFilterValues((item) => ({
                          ...item,
                          transactionStatus: newValue || null,
                        }));
                      }}
                      withoutSearchButton
                    />
                  </div>
                </div>
                <div className="w-100 d-flex-inline d-flex-v-center-h-center mt-2">
                  <div className="w-50  d-flex d-flex-h-center-v-center">
                    <div className="date-type-select">
                      <SelectComponet
                        data={[
                          {
                            key: 1,
                            value: `${translationPath}commission-payment-date`,
                          },
                        ]}
                        defaultValue={{
                          key: 1,
                          value: `${translationPath}commission-payment-date`,
                        }}
                        value={dateFilter.selectedDateType || 1}
                        valueInput="key"
                        textInput="value"
                        onSelectChanged={(value) => {
                          setIsDatePickerChanged(true);
                          setDateFilter((f) => ({
                            ...f,
                            selectedDateType: value,
                          }));
                        }}
                        wrapperClasses="w-auto"
                        themeClass="theme-transparent"
                        idRef="Date_Select"
                        parentTranslationPath={parentTranslationPath}
                        translationPath={translationPath}
                        translationPathForData={translationPath}
                      />
                    </div>
                    <DateRangePickerComponent
                      onClearClicked={() => {
                        setDateFilter(dateRangeDefault);
                        setIsDatePickerChanged(true);
                      }}
                      onDialogClose={() => setIsDatePickerChanged(true)}
                      ranges={[dateFilter]}
                      parentTranslationPath={parentTranslationPath}
                      translationPath={translationPath}
                      onDateChanged={(selectedDate) => {
                        setDateFilter((item) => ({
                          ...item,
                          selectedDateType: 1,
                          startDate: selectedDate?.selection?.startDate,
                          endDate: new Date(
                            moment(selectedDate?.selection?.endDate).endOf(
                              "day"
                            )
                          ),
                          key: "selection",
                        }));
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
